export default __webpack_public_path__ + "static/media/dice-coin.b4f799b3.webp";